// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"spring-sale-promo-banner_saveTag__fiK0L","text":"spring-sale-promo-banner_text__XxsFy"};